// Resolves an image reference to a usable URL.
// External URLs are returned as-is; storage paths get the backend URL prepended.
export const resolveImg = (u) =>
  u && u.startsWith('http') ? u : `${process.env.REACT_APP_BACKEND_URL}/${u}`;
